(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["icetool-accessories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('icetool-accessories')) {
    customElements.define('icetool-accessories', class extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        if (!this.form || !this.querySelector('input[type="checkbox"]')) return;
        this.hidden = false;
        this.onChange = () => {
          const selected = this.querySelector('input:checked');
          this.form.querySelectorAll('.shopify-payment-button').forEach(button => {
            button.hidden = Boolean(selected);
          });
        };
        this.onSubmit = this.addSelected.bind(this);
        this.addEventListener('change', this.onChange);
        this.form.addEventListener('submit', this.onSubmit, true);
        this.onChange();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.form?.removeEventListener('submit', this.onSubmit, true);
      }

      async addSelected(event) {
        const selected = [...this.querySelectorAll('input:checked')];
        if (!selected.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.busy) return;
        const errorBox = this.querySelector('.icetool-accessories__error');
        const showError = message => {
          errorBox.querySelector('span').textContent = message;
          errorBox.hidden = false;
        };
        errorBox.hidden = true;
        if (selected.length > 1 && !this.dataset.combinedVariantId) {
          showError(this.dataset.unavailable);
          return;
        }
        const data = new FormData(this.form);
        const quantity = Math.max(1, Math.floor(Number(data.get('quantity')) || 1));
        const mainItem = { id: String(data.get('id')), quantity };
        const properties = {};
        for (const [key, value] of data) {
          const property = key.match(/^properties\[(.+)\]$/);
          if (property && typeof value === 'string') properties[property[1]] = value;
        }
        if (Object.keys(properties).length) mainItem.properties = properties;
        if (data.get('selling_plan')) mainItem.selling_plan = data.get('selling_plan');
        const accessoryIds = selected.length > 1
          ? [this.dataset.combinedVariantId]
          : selected.map(input => input.value);
        const items = [mainItem, ...accessoryIds.map(id => ({ id, quantity }))];
        const controls = [...this.form.querySelectorAll('button[type="submit"], input[type="checkbox"]')];
        const disabledStates = controls.map(control => control.disabled);
        this.busy = true;
        this.form.setAttribute('aria-busy', 'true');
        controls.forEach(control => { control.disabled = true; });
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items })
          });
          const result = await response.json();
          if (!response.ok) {
            showError(typeof result.description === 'string' ? result.description : this.dataset.unavailable);
            return;
          }
          window.location.assign(this.dataset.cartUrl);
        } catch {
          showError(this.dataset.error);
        } finally {
          this.busy = false;
          this.form.removeAttribute('aria-busy');
          controls.forEach((control, index) => { control.disabled = disabledStates[index]; });
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
